import { Box, Skeleton, Stack, Text } from "@chakra-ui/react";
import React from "react";

import { MarginProcessingError } from "../../types";

type Props = {
  children: React.ReactNode;
  isLoading: boolean;
  hasData: boolean;
  error: MarginProcessingError | null;
};

export const SectionLoadingState = () => {
  return (
    <Stack spacing={3}>
      <Skeleton h="35px" />
      <Skeleton h="35px" />
      <Skeleton h="35px" />
    </Stack>
  );
};

function RenderState({ children, isLoading, hasData, error }: Props) {
  if (isLoading) {
    return <SectionLoadingState />;
  }
  if (hasData) {
    return <>{children}</>;
  }

  if (error && error?.response?.status === 500) {
    return (
      <Box>
        <Text fontWeight="bold">
          System unavailable. Sorry, this system is temporarily unavailable.
        </Text>
      </Box>
    );
  }

  if (error?.response?.status && error.response?.status >= 400) {
    return (
      <Box>
        <Text fontWeight="bold">
          The request failed. {error?.response?.data?.errorDescription}
        </Text>
      </Box>
    );
  }

  return (
    <Box>
      <Text fontWeight="bold">
        There was an error retrieving this data, try again later.
      </Text>
    </Box>
  );
}

export default RenderState;
